import * as types from './stockManageActionType'
const initialState = {
  busStation: [],
  counterList: [],
  manageStockTableData: [],
  issueStockTableData: [],
  skipStockTableData: [],
  tranferStockTableData: [],
}
const stockManageReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.MANAGE_STOCKTABLEDATA:
      return { ...state, manageStockTableData: action.payload };
    case types.ISSUE_STOCKTABLEDATA:
      return { ...state, issueStockTableData: action.payload };
    case types.BUS_STATION:
      return { ...state, busStation: action.payload };
    case types.COUNTER_LIST:
      return { ...state, counterList: action.payload };
    case types.SKIP_STOCKTABLEDATA:
      return { ...state, skipStockTableData: action.payload };
    case types.TRASFER_STOCKTABLEDATA:
      return { ...state, tranferStockTableData: action.payload };
    default:
      return state;
  }
}

export default stockManageReducer
